export enum DocumentTemplatePermissions {
  GET_DOCUMENT_TEMPLATES = 'documentTemplate.getDocumentTemplates',
  CREATE_DOCUMENT_TEMPLATE = 'documentTemplate.createDocumentTemplate',
  UPDATE_DOCUMENT_TEMPLATE = 'documentTemplate.updateDocumentTemplate',
  ARCHIVE_DOCUMENT_TEMPLATE = 'documentTemplate.archiveDocumentTemplate',
}
